/**
 * Document Library catalog (`POST /Documents`) sort column keys → API `sort_by`.
 */
export const DOCUMENT_LIBRARY_API_ORDER_BY_FIELD = {
  provider_name: "provider_name",
  document_date: "document_date",
};

export const DOCUMENT_LIBRARY_DEFAULT_SORT_CONFIG = {
  provider_name: { direction: "asc" },
};

/**
 * @param {Record<string, { direction?: string }>} sortConfig
 * @returns {{ orderBy: string | null, sortDirection: 'asc' | 'desc' | null }}
 */
export function sortConfigToDocumentLibraryApiParams(sortConfig) {
  const keys = Object.keys(sortConfig || {});
  if (keys.length === 0) {
    return {
      orderBy: DOCUMENT_LIBRARY_API_ORDER_BY_FIELD.provider_name,
      sortDirection: "asc",
    };
  }
  const columnKey = keys[0];
  const orderBy = DOCUMENT_LIBRARY_API_ORDER_BY_FIELD[columnKey];
  if (!orderBy) {
    return {
      orderBy: DOCUMENT_LIBRARY_API_ORDER_BY_FIELD.provider_name,
      sortDirection: "asc",
    };
  }
  const direction = sortConfig[columnKey]?.direction;
  const sortDirection = direction === "asc" ? "asc" : "desc";
  return { orderBy, sortDirection };
}
